<script lang="ts">
	import { page } from '$app/state';
	import Icon from '$lib/components/icons/Icon.svelte';
	import AutocompleteLine from '$lib/components/search/autocomplete/AutocompleteLine.svelte';
	import { PROFILE_FAVORITES } from '$lib/constants/route';
	import { gotoRelativeUrl } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	interface Props {
		activeItemIndex: number;
		value: string;
		onmouseover: (index: number) => void;
	}

	const { onmouseover, activeItemIndex, value }: Props = $props();

	const { userProfileStore } = page.data;
	const FAVORITE_INDEX_VALUE = -2;
</script>

{#if $userProfileStore?.data?.me?.itinerariesFavorites?.length > 0 && value === ''}
	<AutocompleteLine
		id="favorite-cta"
		label=""
		additionalLabel=""
		onmouseover={() => onmouseover(FAVORITE_INDEX_VALUE)}
		active={activeItemIndex === FAVORITE_INDEX_VALUE}
	>
		{#snippet lineItem()}
			<button
				onclick={() => {
					gotoRelativeUrl(PROFILE_FAVORITES);
				}}
				class="w-full text-md flex items-center gap-2 py-2 overflow-hidden text-ellipsis cursor-pointer truncate border-0 bg-transparent text-left text-primary text-4"
			>
				<Icon icon="bookmark-outline" class="size-4! text-4" />
				{m.bookmark__favorite__routes()}
			</button>
		{/snippet}
	</AutocompleteLine>
{/if}
